import React, { useEffect } from 'react'
import * as con from "../Constants"
import { StateStoredValue } from '../hooks/StoreHooks'
import { Radio, Typography } from 'antd'
import { RefLanguage } from '../hooks/LanguageHooks';


const { Text } = Typography;


function DatabaseSelector({ onDatabaseSelect }) {

    // Database type
    const [selectedDatabase, setSelectedDatabase] = StateStoredValue(con.SELECTED_DATABASE)

    const i18n = RefLanguage()

    // Notify parent component when the database changes
    useEffect(() => {
        if (onDatabaseSelect && selectedDatabase) {
            onDatabaseSelect(selectedDatabase);
        }
    }, [selectedDatabase, onDatabaseSelect]);


    return (
        <div data-tour="database-selector">
            <Typography style={{ marginBottom: "1vh" }}>
                <Text style={{ fontSize: "var(--command-text-size)", fontWeight: "bold" }} >{i18n.t("selectedDatabase")}</Text>
            </Typography>
            <Radio.Group
                value={selectedDatabase}
                options={[
                    { value: con.DATABASE_ITS, label: "ITS" },
                    { value: con.DATABASE_SSU, label: "SSU" },
                    { value: con.DATABASE_LSU, label: "LSU" },
                    { value: con.DATABASE_LrRNA, label: "Long rRNA" },
                ]}
                onChange={(e) => setSelectedDatabase(e.target.value)}
            />
        </div>
    )
}

// Add default props to avoid errors if parent doesn't provide onDatabaseSelect
DatabaseSelector.defaultProps = {
    onDatabaseSelect: null
}

export default DatabaseSelector
